/* eslint-disable react-hooks/exhaustive-deps */

import { useMutation } from "@apollo/client";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router";
import { graphql } from "../../../api/__generated__";
import SittingHuman from "../../illustrations/human-sorry-sitting";
import LoadingPage from "../../layout/LoadingPage";
import OnboardingContainer from "../../layout/wizard/OnboardingContainer";
import OnboardingStepContainer from "../../layout/wizard/OnboardingStepContainer";
import ErrorPage from "../../ui/ErrorPage";

const confirmConsultationMutation = graphql(`
  mutation ConfirmConsultation($input: ConfirmConsultationInput!) {
    confirmConsultation(input: $input) {
      id
      acceptedByHuman
      acceptedByProfessional
      status
      uuid
    }
  }
`);

export default function ConfirmConsultationPage() {
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  const { t } = useTranslation();

  const [confirmConsultation, { error, loading }] = useMutation(
    confirmConsultationMutation,
  );

  useEffect(() => {
    confirmConsultation({
      variables: { input: { email: email || "", uuid: `${uuid}` } },
    });
  }, [confirmConsultation, email, uuid]);

  if (error && error.message !== "CONSULTATION_ALREADY_ACCEPTED")
    return <ErrorPage />;

  if (loading) return <LoadingPage full />;

  return (
    <OnboardingContainer>
      <OnboardingStepContainer
        fullCopyright
        headline="Op Gesprek"
        showSpecialConditionsForTherapist={false}
      >
        <div className="content">
          <div className="content__container content__container__narrow">
            <Box className="illustration" mt={5}>
              <SittingHuman />
            </Box>
            <Box className="description" mt={5}>
              <Typography variant="subtitle2">
                {t("human:confirm.consultation.success.title")}
              </Typography>
              <Typography variant="body1">
                {t("human:confirm.consultation.success.body")}
              </Typography>
            </Box>
          </div>
        </div>
      </OnboardingStepContainer>
    </OnboardingContainer>
  );
}
